import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoModelloVersamentoStep2Component } from './conservazione-carica-documento-modello-versamento-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-modello-versamento-step2', {
            url: '/conservazione-carica-modello-versamento',
            ncyBreadcrumb: {
                label: 'Carica Modelli Versamento',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-modello-versamento-step2 flex="100"></conservazione-carica-documento-modello-versamento-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoModelloVersamentoStep2Module: string = ng
    .module('conservazione-carica-documento-modello-versamento-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoModelloVersamentoStep2', ConservazioneCaricaDocumentoModelloVersamentoStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-modello-versamento-step2/conservazione-carica-documento-modello-versamento-step2.module.ts